import Async from "components/DesignSystem/AsyncComponents/Async";
import { Button } from "components/DesignSystem/Button/Button";
import Loader from "components/DesignSystem/Loader/loader";
import Modal from "components/DesignSystem/Modal/Modal";
import { LinkableFinancialClosing } from "store/apis/requestDocument";
import { LinkFinancialClosing } from "./LinkFinancialClosing";

const LoadingClosings = () => (
  <Modal.Content size="regular">
    <Modal.Header>
      <Modal.Title>Request Documents</Modal.Title>
      <Modal.Close />
    </Modal.Header>
    <Modal.Body>
      <div className="t-flex t-justify-center t-items-center t-py-6">
        <Loader size="small" />
      </div>
    </Modal.Body>
  </Modal.Content>
);

const ClosingsLoadError = ({
  onRetry,
  onSkip,
  onCancel,
}: {
  onRetry: () => void;
  onSkip: () => void;
  onCancel: () => void;
}) => (
  <Modal.Content size="regular">
    <Modal.Header>
      <Modal.Title>Link to financial closing</Modal.Title>
      <Modal.Close />
    </Modal.Header>
    <Modal.Body className="sm:t-px-4">
      <span className="t-text-body-sm t-text-text-30">
        We couldn't load the financial closings for this chat. Try again, or
        send the request without linking it to a closing.
      </span>
    </Modal.Body>
    <Modal.Footer>
      <div className="t-flex t-justify-end t-gap-2">
        <Button type="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="button" onClick={onSkip}>
          Continue without linking
        </Button>
        <Button type="button" customType="primary" onClick={onRetry}>
          Retry
        </Button>
      </div>
    </Modal.Footer>
  </Modal.Content>
);

// First step of a new document request: pick the closing it belongs to
export const LinkFinancialClosingStep = ({
  closings,
  isLoading,
  isError,
  selectedClosingId,
  onSelect,
  onNext,
  onSkip,
  onRetry,
  onCancel,
}: {
  closings: LinkableFinancialClosing[];
  isLoading: boolean;
  isError: boolean;
  selectedClosingId: string | null;
  onSelect: (closingId: string) => void;
  onNext: () => void;
  onSkip: () => void;
  onRetry: () => void;
  onCancel: () => void;
}) => (
  <Modal.Root open onOpenChange={onCancel}>
    <Async.Root
      isLoading={isLoading}
      isSuccess={!isError}
      isError={isError}
      isEmpty={false}
      renderOnLoad={<LoadingClosings />}
    >
      <Async.ErrorHandler>
        <ClosingsLoadError
          onRetry={onRetry}
          onSkip={onSkip}
          onCancel={onCancel}
        />
      </Async.ErrorHandler>
      <Async.Success>
        <LinkFinancialClosing
          closings={closings}
          selectedClosingId={selectedClosingId}
          onSelect={onSelect}
          onNext={onNext}
          onCancel={onCancel}
        />
      </Async.Success>
    </Async.Root>
  </Modal.Root>
);
